import React, { useState } from 'react'

import SectionContainer from 'components/atoms/SectionContainer'
import Container from 'components/atoms/Container'
import Markdown from 'components/atoms/MarkdownContent'
import Typography from 'components/atoms/Typography'
import FAQ from 'components/paperplane/FAQ'

import faqData from './faqData.json'

const PaperplaneFAQ = () => {
  const initialState = () => faqData.map((faq, idx) => ({
    ...faq,
    active: idx === 0,
    id: idx,
    answer: <Markdown content={faq.answer} className="paperplane-faq__answer"/>,
  }))
  const [faqs, setFaqs] = useState(initialState())

  const toggleAnswer = (id) => {
    const newFaqs = faqs.map(faq => (
        faq.id === id ? { ...faq, active: !faq.active } : { ...faq, active: false }
      )
    )
    setFaqs(newFaqs)
  }

  return (
    <div className="paperplane-faq">
      <SectionContainer
        paddingTop={80}
        paddingBottom={80}
      >
        <Container next>
          <div className="paperplane-faq__heading">
            <Typography component="h2" variant="title" className="text-variant-title-sm m-b-sm">
              Pertanyaan Seputar Hasil Cek Peluang SBMPTN
            </Typography>
            <Typography component="p" variant="body" className="paperplane-faq__subtitle">
              Ada pertanyaan? Langsung saja cek jawaban dari pertanyaan seputar Cek Peluang SBMPTN di bawah ini.
            </Typography>
          </div>
          {
            faqs.map(faq => (
              <FAQ
                question={faq.question}
                answer={faq.answer}
                active={faq.active}
                key={`paperplane-faq-itm-${faq.id}`}
                onClick={() => toggleAnswer(faq.id)}
              />
            ))
          }
        </Container>
        <style jsx>
          {`
            .paperplane-faq {
              &__heading {
                margin-bottom: 40px;
                color: #1a344f;
              }
              :global(&__answer) {
                :global(p:last-child) {
                  margin: 0 !important;
                }
              }

              @media screen and (max-width: 767px) {
                margin-bottom: 24px;
                :global(&__subtitle) {
                  line-height: 1.5 !important;
                  font-size: 14px !important;
                }
              }
            }
          `}
        </style>
      </SectionContainer>
    </div>
  )
}

export default PaperplaneFAQ
